import React from 'react'
import styles from '../../../CSS/main.css'

const DropdownGroup: React.FC = ({ children }) => {
  return <div className={styles.LinkGroup}>{children}</div>
}

export default DropdownGroup
